<template>
  <BaseNoticeItem :completed="isComplete">
    <template #head>
      <strong>
        {{ $t(contractDoc.docTypeName) }}
      </strong>
      <WdsTooltip
        v-if="contractDoc.docTypeHelp !== null"
        :text="$t(contractDoc.docTypeHelp)"
        class="tw-ml-1"
      >
        <i class="zmdi zmdi-help f-15"></i>
      </WdsTooltip>
    </template>
    <template #body>
      <span v-if="isComplete">
        {{ $t('You have accepted the document') }}
      </span>
      <span v-else>
        {{
          $t(
            'Please review and confirm, that you have read and accepted the contents of the document.',
          )
        }}
      </span>
    </template>
    <template #status>
      Status:
      <span v-if="isComplete">
        {{ $t('Completed') }}
      </span>
      <span v-else>
        {{ $t('Acceptance needed') }}
      </span>
    </template>
    <template #action>
      <a
        v-if="isComplete"
        :href="contractDoc.pdfUrl"
        target="_blank"
        class="btn btn-default btn-xs"
      >
        <span class="glyphicon glyphicon-save-file"></span>
        {{ $t('Download') }}
      </a>
      <template v-else>
        <AcceptContractDocModal
          v-model="showModal"
          :contract-doc="contractDoc"
          @accepted="onAccepted"
        />

        <a
          href="#"
          class="btn btn-primary btn-xs"
          data-test="accept-kid-button"
          @click="onClickActionReview"
        >
          {{ $t('Review') }}
        </a>
      </template>
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import { ref } from 'vue'
import { WdsTooltip } from '@worksome/wds-components'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import AcceptContractDocModal from '@/components/compliances/modals/AcceptContractDocModal.vue'

defineProps({
  contractDoc: {
    type: Object,
    required: true,
  },
  isComplete: {
    type: Boolean,
    required: true,
  },
})

const showModal = ref(false)

function onClickActionReview() {
  showModal.value = true
}

function onAccepted() {
  window.location.reload()
}
</script>
